/* EUSU NON-SELLING STOCK (2026-10-26) — the weekly EUSU stock status workbook as a screen. Codes (EUSU, SKU, T1, USD,
   WoW) and the workbook's own cause names stay as they are in every language. */
const en = {
  title: 'EUSU Non-Selling Stock',
  week: 'Week',
  sheet: 'Sheet {{s}}',
  lastUpload: 'Last upload: {{file}} · {{by}} · {{at}}',
  upload: 'Upload this week\'s workbook',
  uploadHint: "The warehouse's \"Helinox Inventory Status For Finished Goods\" file (.xls or .xlsx) — one week, its Closing Date. Add a \"Remark\" column by hand if you want remarks. The old \"EUSU stock status\" workbook is still read.",
  tabOverview: 'Overview',
  tabCause: 'By root cause',
  tabWow: 'WoW change',
  kQty: 'Total qty',
  kAmt: 'Total amount (USD)',
  kSkus: 'SKU lines',
  kSkusSub: 'Non-selling lines',
  kCauses: 'Root causes',
  kCausesSub: 'Types',
  vsPrev: 'vs {{d}}',
  noPrev: 'No earlier week',
  qtyByCause: 'Stock qty by root cause',
  amtByCause: 'Stock amount by root cause (USD)',
  trendQty: 'Total qty, last 12 weeks',
  trendAmt: 'Total amount, last 12 weeks (USD)',
  causeSummary: 'Root cause summary',
  cause: 'Root cause',
  qty: 'Qty',
  amount: 'Amount (USD)',
  share: 'Amount %',
  skus: 'SKUs',
  total: 'Total',
  all: 'All causes',
  search: 'Search SKU or product',
  skuDetail: 'SKU detail',
  sku: 'SKU#',
  product: 'Product',
  collection: 'Collection',
  vendor: 'Vendor',
  t1: 'T1 price',
  remark: 'Remark',
  nRows: '{{n}} rows',
  dQty: 'Δ Qty',
  dAmt: 'Δ Amount',
  curQty: 'Current qty',
  curAmt: 'Current amount',
  changed: 'Changed SKUs vs {{d}}',
  changedN: 'SKUs changed',
  kQtyChange: 'Total qty change',
  kAmtChange: 'Total amount change',
  kUp: 'Increased SKUs',
  kDown: 'Decreased SKUs',
  changedAt: '{{d}} vs {{vs}} changed SKUs',
  wowQty: 'Δ Qty vs {{d}}',
  wowAmt: 'Δ Amount vs {{d}}',
  noChange: 'Nothing changed between {{p}} and {{d}}.',
  lastChange: 'Nothing changed between {{p}} and {{d}}. The most recent change was {{from}} → {{to}}: qty {{q}}, amount {{a}} — listed below.',
  firstWeek: 'This is the earliest week on the portal — there is nothing to compare it with.',
  keyNote: 'Matched on SKU# + cause + collection + vendor, so a SKU listed twice under different causes is compared line by line.',
  empty: 'No week has been uploaded yet.',
  emptyUpload: "Upload the EUSU inventory status file to start.",
  previewTitle: 'Read from {{file}}',
  previewSub: '{{n}} weeks found. A week already on the portal is replaced by this file\'s version.',
  stNew: 'New',
  stReplace: 'Replaces',
  stSame: 'Unchanged',
  skippedN: '{{n}} sheets skipped',
  skippedWhy: 'Sheets without the standard header (SKU# · Cause · Qty · Purchase Amount) are not read.',
  rows: 'Rows',
  save: 'Save {{n}} weeks',
  cancel: 'Cancel',
  reading: 'Reading the workbook…',
  saved: 'Saved {{n}} weeks from {{file}}.',
  close: 'Close',
  exportXlsx: 'Export Excel',
  downloadHtml: 'Download HTML',
  htmlHint: 'The dashboard page for this week as one HTML file, to keep or send.',
  shareLink: 'Share link',
  shareTitle: 'HTML link — always the latest week',
  shareSub: 'Opens the dashboard page with no portal sign-in. It always shows the latest uploaded week: when a new workbook is uploaded, the same link shows it.',
  shareWarn: 'Anyone who has the link can read every figure on it, vendors and purchase prices included. Send it only inside the company. Replace it to stop the old link working.',
  noLink: 'There is no link yet.',
  makeLink: 'Make a link',
  replaceLink: 'Replace the link',
  switchOff: 'Switch the link off',
  copy: 'Copy',
  copied: 'Copied',
  open: 'Open',
  invPreviewSub: "One week: {{n}} non-selling lines (Available Qty above 0); {{zero}} rows with nothing available are left out. A week already on the portal is replaced.",
  flagN_code: "{{n}} item codes not found in the product database",
  flagN_name: "{{n}} item codes whose product name does not fit the product database",
  flagN_cause: "{{n}} lines with no root cause",
  flagN_price: "{{n}} lines with no price",
  flagNone: "Every item code, root cause and price was found.",
  ruleN: "{{n}} lines got \"Pre-build\" from the PO",
  lastPriceN: "{{n}} lines had no price in the file — last week's price is used",
  noRemarkCol: "No \"Remark\" column in this file — remarks stay empty.",
  itemCode: "Item code",
  issue: "To fix",
  flag_code: "Item code not in the product database",
  flag_name: "Item code may be wrong",
  flag_cause: "Root cause missing",
  flag_price: "Price missing",
  fixAfter: "Save, then set these on the screen (above the tabs).",
  needsTitle: "{{n}} lines need an update",
  needsSub: "The file could not settle these. Set each one here — a SAP code and a root cause are remembered for later files.",
  needsSubRead: "The file could not settle these; somebody who uploads the file can set them.",
  fixSave: "Save",
  nameIs: "product database: {{name}} ({{sap}})",
  nameOk: "The code is right",
  sapPh: "SAP code",
  causePh: "Root cause",
  linkInv: "Also load it into the Global Inventory Report as EUSU for Friday {{day}}",
  linkInvFri: "Today is Friday: this file is the week's EUSU stock there (ticked by default).",
  linkInvOther: "Not a Friday: tick only if this file should stand for that Friday's EUSU stock.",
  linked: "Loaded into the Global Inventory Report as EUSU for {{day}} ({{n}} lines).",
  linkFailed: "Loading it into the Global Inventory Report failed: {{e}}",
};
const ko = {
  title: 'EUSU 비매 재고',
  week: '주차',
  sheet: '시트 {{s}}',
  lastUpload: '최근 업로드: {{file}} · {{by}} · {{at}}',
  upload: '이번 주 엑셀 업로드',
  uploadHint: "창고의 \"Helinox Inventory Status For Finished Goods\" 파일(.xls 또는 .xlsx) — Closing Date 기준 한 주. 비고가 필요하면 \"Remark\" 열을 직접 추가하세요. 기존 \"EUSU stock status\" 파일도 읽습니다.",
  tabOverview: '개요',
  tabCause: '원인별',
  tabWow: '주간 변동',
  kQty: '총 재고 수량',
  kAmt: '총 재고 금액 (USD)',
  kSkus: 'SKU 행',
  kSkusSub: '비매 행',
  kCauses: 'Root Cause 수',
  kCausesSub: '유형',
  vsPrev: '{{d}} 대비',
  noPrev: '이전 주차 없음',
  qtyByCause: 'Root Cause별 재고 수량',
  amtByCause: 'Root Cause별 재고 금액 (USD)',
  trendQty: '총 재고 수량 추이 (최근 12주)',
  trendAmt: '총 재고 금액 추이 (최근 12주, USD)',
  causeSummary: 'Root Cause별 현황 요약',
  cause: '원인',
  qty: '수량',
  amount: '금액 (USD)',
  share: '금액 비중',
  skus: 'SKU 수',
  total: '합계',
  all: '전체',
  search: 'SKU 또는 제품명 검색',
  skuDetail: 'SKU 상세',
  sku: 'SKU#',
  product: '제품명',
  collection: '컬렉션',
  vendor: '벤더',
  t1: 'T1 단가',
  remark: '비고',
  nRows: '{{n}}행',
  dQty: '수량 변동',
  dAmt: '금액 변동',
  curQty: '현재 수량',
  curAmt: '현재 금액',
  changed: '{{d}} 대비 변동 SKU',
  changedN: '변동 SKU',
  kQtyChange: '총 수량 변동',
  kAmtChange: '총 금액 변동',
  kUp: '증가 SKU',
  kDown: '감소 SKU',
  changedAt: '{{d}} vs {{vs}} 변동 SKU',
  wowQty: '{{d}} 대비 수량 변동',
  wowAmt: '{{d}} 대비 금액 변동',
  noChange: '{{p}}와 {{d}} 사이에 변동이 없습니다.',
  lastChange: '{{p}}와 {{d}} 사이에 변동이 없습니다. 가장 최근 변동은 {{from}} → {{to}}: 수량 {{q}}, 금액 {{a}} — 아래에 표시합니다.',
  firstWeek: '포털에 있는 가장 이른 주차라 비교할 주차가 없습니다.',
  keyNote: 'SKU# + 원인 + 컬렉션 + 벤더 조합으로 매칭하므로, 같은 SKU가 다른 원인으로 두 번 있어도 행별로 비교됩니다.',
  empty: '아직 업로드된 주차가 없습니다.',
  emptyUpload: "EUSU 재고 현황 파일을 업로드해 시작하세요.",
  previewTitle: '{{file}}에서 읽음',
  previewSub: '{{n}}개 주차를 찾았습니다. 포털에 이미 있는 주차는 이 파일의 내용으로 바뀝니다.',
  stNew: '신규',
  stReplace: '교체',
  stSame: '변경 없음',
  skippedN: '{{n}}개 시트 제외',
  skippedWhy: '표준 헤더(SKU# · Cause · Qty · Purchase Amount)가 없는 시트는 읽지 않습니다.',
  rows: '행',
  save: '{{n}}개 주차 저장',
  cancel: '취소',
  reading: '엑셀을 읽는 중…',
  saved: '{{file}}에서 {{n}}개 주차를 저장했습니다.',
  close: '닫기',
  exportXlsx: '엑셀 내보내기',
  downloadHtml: 'HTML 다운로드',
  htmlHint: '이번 주 대시보드를 HTML 파일 하나로 저장하거나 보낼 수 있습니다.',
  shareLink: '공유 링크',
  shareTitle: 'HTML 링크 — 항상 최신 주차',
  shareSub: '포털 로그인 없이 대시보드를 엽니다. 항상 최근 업로드된 주차를 보여주며, 새 엑셀을 올리면 같은 링크에 반영됩니다.',
  shareWarn: '링크를 가진 누구나 벤더와 구매 단가를 포함한 모든 수치를 볼 수 있습니다. 사내에서만 공유하세요. 링크를 교체하면 이전 링크는 작동하지 않습니다.',
  noLink: '아직 링크가 없습니다.',
  makeLink: '링크 만들기',
  replaceLink: '링크 교체',
  switchOff: '링크 끄기',
  copy: '복사',
  copied: '복사됨',
  open: '열기',
  invPreviewSub: "한 주: 비판매 {{n}}줄(Available Qty > 0). 가용 수량이 없는 {{zero}}줄은 제외됩니다. 포털에 이미 있는 주차는 교체됩니다.",
  flagN_code: "제품 DB에 없는 품목 코드 {{n}}개",
  flagN_name: "제품 DB의 제품명과 맞지 않는 품목 코드 {{n}}개",
  flagN_cause: "원인이 없는 줄 {{n}}개",
  flagN_price: "단가가 없는 줄 {{n}}개",
  flagNone: "모든 품목 코드, 원인, 단가를 찾았습니다.",
  ruleN: "{{n}}줄은 PO에서 \"Pre-build\"로 지정",
  lastPriceN: "{{n}}줄은 파일에 단가가 없어 지난주 단가를 사용",
  noRemarkCol: "이 파일에 \"Remark\" 열이 없어 비고는 비어 있습니다.",
  itemCode: "품목 코드",
  issue: "수정 필요",
  flag_code: "제품 DB에 없는 품목 코드",
  flag_name: "품목 코드 오류 가능",
  flag_cause: "원인 없음",
  flag_price: "단가 없음",
  fixAfter: "저장한 뒤 화면(탭 위)에서 입력하세요.",
  needsTitle: "업데이트가 필요한 줄 {{n}}개",
  needsSub: "파일만으로 정하지 못한 항목입니다. 여기서 입력하세요 — SAP 코드와 원인은 다음 파일에도 기억됩니다.",
  needsSubRead: "파일만으로 정하지 못한 항목입니다. 업로드 권한이 있는 사람이 입력할 수 있습니다.",
  fixSave: "저장",
  nameIs: "제품 DB: {{name}} ({{sap}})",
  nameOk: "코드가 맞음",
  sapPh: "SAP 코드",
  causePh: "원인",
  linkInv: "Global Inventory Report에도 {{day}}(금) EUSU 재고로 반영",
  linkInvFri: "오늘은 금요일: 이 파일이 그 주의 EUSU 재고가 됩니다(기본 선택).",
  linkInvOther: "금요일이 아님: 이 파일을 그 금요일의 EUSU 재고로 쓸 때만 선택하세요.",
  linked: "Global Inventory Report에 {{day}} EUSU로 반영했습니다({{n}}줄).",
  linkFailed: "Global Inventory Report 반영 실패: {{e}}",
};
const vi = {
  title: 'Tồn kho không bán EUSU',
  week: 'Tuần',
  sheet: 'Sheet {{s}}',
  lastUpload: 'Upload gần nhất: {{file}} · {{by}} · {{at}}',
  upload: 'Upload file tuần này',
  uploadHint: "File \"Helinox Inventory Status For Finished Goods\" của kho (.xls hoặc .xlsx) — một tuần, theo Closing Date. Cần remark thì tự thêm cột \"Remark\" vào file. File \"EUSU stock status\" cũ vẫn đọc được.",
  tabOverview: 'Tổng quan',
  tabCause: 'Theo nguyên nhân',
  tabWow: 'Thay đổi WoW',
  kQty: 'Tổng số lượng',
  kAmt: 'Tổng giá trị (USD)',
  kSkus: 'Dòng SKU',
  kSkusSub: 'Dòng hàng không bán',
  kCauses: 'Nguyên nhân',
  kCausesSub: 'Loại',
  vsPrev: 'so với {{d}}',
  noPrev: 'Không có tuần trước',
  qtyByCause: 'Số lượng tồn theo nguyên nhân',
  amtByCause: 'Giá trị tồn theo nguyên nhân (USD)',
  trendQty: 'Tổng số lượng, 12 tuần gần nhất',
  trendAmt: 'Tổng giá trị, 12 tuần gần nhất (USD)',
  causeSummary: 'Tóm tắt theo nguyên nhân',
  cause: 'Nguyên nhân',
  qty: 'Số lượng',
  amount: 'Giá trị (USD)',
  share: '% giá trị',
  skus: 'SKU',
  total: 'Tổng',
  all: 'Tất cả',
  search: 'Tìm SKU hoặc sản phẩm',
  skuDetail: 'Chi tiết SKU',
  sku: 'SKU#',
  product: 'Sản phẩm',
  collection: 'Collection',
  vendor: 'Nhà cung cấp',
  t1: 'Giá T1',
  remark: 'Ghi chú',
  nRows: '{{n}} dòng',
  dQty: 'Δ Số lượng',
  dAmt: 'Δ Giá trị',
  curQty: 'Số lượng hiện tại',
  curAmt: 'Giá trị hiện tại',
  changed: 'SKU thay đổi so với {{d}}',
  changedN: 'SKU thay đổi',
  kQtyChange: 'Tổng thay đổi số lượng',
  kAmtChange: 'Tổng thay đổi giá trị',
  kUp: 'SKU tăng',
  kDown: 'SKU giảm',
  changedAt: 'SKU thay đổi {{d}} so với {{vs}}',
  wowQty: 'Δ Số lượng so với {{d}}',
  wowAmt: 'Δ Giá trị so với {{d}}',
  noChange: 'Không có thay đổi giữa {{p}} và {{d}}.',
  lastChange: 'Không có thay đổi giữa {{p}} và {{d}}. Thay đổi gần nhất là {{from}} → {{to}}: số lượng {{q}}, giá trị {{a}} — liệt kê bên dưới.',
  firstWeek: 'Đây là tuần sớm nhất trên portal — chưa có tuần nào để so sánh.',
  keyNote: 'So khớp theo SKU# + nguyên nhân + collection + nhà cung cấp, nên một SKU nằm hai dòng với hai nguyên nhân vẫn được so từng dòng.',
  empty: 'Chưa có tuần nào được upload.',
  emptyUpload: "Upload file tồn kho EUSU để bắt đầu.",
  previewTitle: 'Đọc từ {{file}}',
  previewSub: 'Tìm thấy {{n}} tuần. Tuần đã có trên portal sẽ được thay bằng dữ liệu của file này.',
  stNew: 'Mới',
  stReplace: 'Thay thế',
  stSame: 'Không đổi',
  skippedN: 'Bỏ qua {{n}} sheet',
  skippedWhy: 'Sheet không có header chuẩn (SKU# · Cause · Qty · Purchase Amount) thì không đọc.',
  rows: 'Dòng',
  save: 'Lưu {{n}} tuần',
  cancel: 'Huỷ',
  reading: 'Đang đọc file…',
  saved: 'Đã lưu {{n}} tuần từ {{file}}.',
  close: 'Đóng',
  exportXlsx: 'Xuất Excel',
  downloadHtml: 'Tải HTML',
  htmlHint: 'Trang dashboard của tuần này thành một file HTML để lưu hoặc gửi.',
  shareLink: 'Link chia sẻ',
  shareTitle: 'Link HTML — luôn là tuần mới nhất',
  shareSub: 'Mở trang dashboard mà không cần đăng nhập portal. Link luôn hiện tuần upload gần nhất: upload file mới thì cùng link sẽ hiện số mới.',
  shareWarn: 'Ai có link đều xem được mọi số liệu, kể cả nhà cung cấp và giá mua. Chỉ gửi trong công ty. Thay link để link cũ ngừng hoạt động.',
  noLink: 'Chưa có link.',
  makeLink: 'Tạo link',
  replaceLink: 'Thay link',
  switchOff: 'Tắt link',
  copy: 'Sao chép',
  copied: 'Đã sao chép',
  open: 'Mở',
  invPreviewSub: "Một tuần: {{n}} dòng non-selling (Available Qty > 0); {{zero}} dòng không còn hàng available được bỏ qua. Tuần đã có trên portal sẽ được thay.",
  flagN_code: "{{n}} item code không có trong database sản phẩm",
  flagN_name: "{{n}} item code có tên sản phẩm không khớp database",
  flagN_cause: "{{n}} dòng chưa có root cause",
  flagN_price: "{{n}} dòng chưa có giá",
  flagNone: "Đã tìm được đủ item code, root cause và giá.",
  ruleN: "{{n}} dòng tự gán \"Pre-build\" theo PO",
  lastPriceN: "{{n}} dòng file không có giá — dùng giá tuần trước",
  noRemarkCol: "File này không có cột \"Remark\" — remark để trống.",
  itemCode: "Item code",
  issue: "Cần sửa",
  flag_code: "Item code không có trong database",
  flag_name: "Item code có thể sai",
  flag_cause: "Thiếu root cause",
  flag_price: "Thiếu giá",
  fixAfter: "Lưu xong thì cập nhật ngay trên màn hình (phía trên các tab).",
  needsTitle: "{{n}} dòng cần cập nhật",
  needsSub: "File không tự xác định được các mục này. Nhập ở đây — SAP code và root cause sẽ được nhớ cho các file sau.",
  needsSubRead: "File không tự xác định được các mục này; người có quyền upload sẽ cập nhật.",
  fixSave: "Lưu",
  nameIs: "database sản phẩm: {{name}} ({{sap}})",
  nameOk: "Code đúng rồi",
  sapPh: "SAP code",
  causePh: "Root cause",
  linkInv: "Nạp luôn vào Global Inventory Report làm EUSU cho thứ 6 {{day}}",
  linkInvFri: "Hôm nay là thứ 6: file này là tồn kho EUSU của tuần bên đó (tick sẵn).",
  linkInvOther: "Không phải thứ 6: chỉ tick nếu file này dùng làm tồn kho EUSU của thứ 6 đó.",
  linked: "Đã nạp vào Global Inventory Report làm EUSU ngày {{day}} ({{n}} dòng).",
  linkFailed: "Nạp vào Global Inventory Report bị lỗi: {{e}}",
};
const zh = {
  title: 'EUSU 非销售库存',
  week: '周次',
  sheet: '工作表 {{s}}',
  lastUpload: '最近上传：{{file}} · {{by}} · {{at}}',
  upload: '上传本周工作簿',
  uploadHint: "仓库的 \"Helinox Inventory Status For Finished Goods\" 文件（.xls 或 .xlsx）— 按 Closing Date 为一周。需要备注请手动添加 \"Remark\" 列。旧的 \"EUSU stock status\" 工作簿仍可读取。",
  tabOverview: '概览',
  tabCause: '按原因',
  tabWow: '周环比',
  kQty: '总数量',
  kAmt: '总金额 (USD)',
  kSkus: 'SKU 行',
  kSkusSub: '非销售行',
  kCauses: '原因数',
  kCausesSub: '类型',
  vsPrev: '对比 {{d}}',
  noPrev: '无上一周',
  qtyByCause: '按原因的库存数量',
  amtByCause: '按原因的库存金额 (USD)',
  trendQty: '总数量，最近 12 周',
  trendAmt: '总金额，最近 12 周 (USD)',
  causeSummary: '按原因汇总',
  cause: '原因',
  qty: '数量',
  amount: '金额 (USD)',
  share: '金额占比',
  skus: 'SKU 数',
  total: '合计',
  all: '全部',
  search: '搜索 SKU 或产品',
  skuDetail: 'SKU 明细',
  sku: 'SKU#',
  product: '产品',
  collection: '系列',
  vendor: '供应商',
  t1: 'T1 单价',
  remark: '备注',
  nRows: '{{n}} 行',
  dQty: 'Δ 数量',
  dAmt: 'Δ 金额',
  curQty: '当前数量',
  curAmt: '当前金额',
  changed: '对比 {{d}} 有变动的 SKU',
  changedN: '变动 SKU',
  kQtyChange: '总数量变动',
  kAmtChange: '总金额变动',
  kUp: '增加的 SKU',
  kDown: '减少的 SKU',
  changedAt: '{{d}} 对比 {{vs}} 变动 SKU',
  wowQty: '对比 {{d}} 的数量变动',
  wowAmt: '对比 {{d}} 的金额变动',
  noChange: '{{p}} 与 {{d}} 之间没有变动。',
  lastChange: '{{p}} 与 {{d}} 之间没有变动。最近一次变动为 {{from}} → {{to}}：数量 {{q}}，金额 {{a}} — 列于下方。',
  firstWeek: '这是门户上最早的一周 — 没有可对比的周次。',
  keyNote: '按 SKU# + 原因 + 系列 + 供应商匹配，同一 SKU 以不同原因列出两次时也会逐行对比。',
  empty: '尚未上传任何周次。',
  emptyUpload: "上传 EUSU 库存状态文件以开始。",
  previewTitle: '读取自 {{file}}',
  previewSub: '找到 {{n}} 周。门户上已有的周次将被此文件的版本替换。',
  stNew: '新增',
  stReplace: '替换',
  stSame: '不变',
  skippedN: '跳过 {{n}} 个工作表',
  skippedWhy: '没有标准表头（SKU# · Cause · Qty · Purchase Amount）的工作表不读取。',
  rows: '行',
  save: '保存 {{n}} 周',
  cancel: '取消',
  reading: '正在读取工作簿…',
  saved: '已从 {{file}} 保存 {{n}} 周。',
  close: '关闭',
  exportXlsx: '导出 Excel',
  downloadHtml: '下载 HTML',
  htmlHint: '将本周看板保存为一个 HTML 文件，便于保存或发送。',
  shareLink: '分享链接',
  shareTitle: 'HTML 链接 — 始终为最新一周',
  shareSub: '无需登录门户即可打开看板。始终显示最近上传的一周：上传新工作簿后，同一链接即显示新数据。',
  shareWarn: '持有链接的任何人都能查看所有数据，包括供应商和采购单价。仅在公司内部分享。替换链接后旧链接将失效。',
  noLink: '尚无链接。',
  makeLink: '创建链接',
  replaceLink: '替换链接',
  switchOff: '关闭链接',
  copy: '复制',
  copied: '已复制',
  open: '打开',
  invPreviewSub: "一周：{{n}} 行非销售库存（Available Qty > 0）；{{zero}} 行无可用数量，已略过。门户上已有的周次将被替换。",
  flagN_code: "{{n}} 个物料代码不在产品数据库中",
  flagN_name: "{{n}} 个物料代码的产品名称与产品数据库不符",
  flagN_cause: "{{n}} 行没有原因",
  flagN_price: "{{n}} 行没有单价",
  flagNone: "所有物料代码、原因和单价都已找到。",
  ruleN: "{{n}} 行按 PO 自动设为 \"Pre-build\"",
  lastPriceN: "{{n}} 行文件中无单价 — 使用上周单价",
  noRemarkCol: "此文件没有 \"Remark\" 列 — 备注为空。",
  itemCode: "物料代码",
  issue: "待处理",
  flag_code: "物料代码不在产品数据库中",
  flag_name: "物料代码可能有误",
  flag_cause: "缺少原因",
  flag_price: "缺少单价",
  fixAfter: "保存后在页面上（标签上方）填写。",
  needsTitle: "{{n}} 行需要更新",
  needsSub: "文件无法确定这些项目。请在此填写 — SAP 代码和原因会为以后的文件记住。",
  needsSubRead: "文件无法确定这些项目；有上传权限的人可以填写。",
  fixSave: "保存",
  nameIs: "产品数据库：{{name}}（{{sap}}）",
  nameOk: "代码无误",
  sapPh: "SAP 代码",
  causePh: "原因",
  linkInv: "同时载入 Global Inventory Report，作为周五 {{day}} 的 EUSU 库存",
  linkInvFri: "今天是周五：此文件即为该周的 EUSU 库存（默认勾选）。",
  linkInvOther: "不是周五：仅当此文件要作为该周五的 EUSU 库存时才勾选。",
  linked: "已载入 Global Inventory Report，作为 {{day}} 的 EUSU（{{n}} 行）。",
  linkFailed: "载入 Global Inventory Report 失败：{{e}}",
};
export default { ns: 'xEusu', en, ko, vi, zh };
